import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { ICardProductDataModel } from '../../models/card-product.datamodel';

@Component({
  selector: 'app-multi-content-module',
  templateUrl: './multi-content-module.component.html',
})
export class MultiContentModuleComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  cards: ICardProductDataModel[] = [];

  constructor(jssStylingService: JssStylingService) {
    this.jssStylingService = jssStylingService;
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('MultiContentModule component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
  
    if((this.rendering.fields.Cards as any)?.length > 0){ 
      for (let i = 0; i < (this.rendering.fields.Cards as any)?.length; i++) {
        let card:ICardProductDataModel = {
          Title: (this.rendering.fields.Cards as any)[i]?.fields?.Title?.value,
          Description: (this.rendering.fields.Cards as any)[i]?.fields?.Description?.value,
          Link: (this.rendering.fields.Cards as any)[i]?.fields?.Link.value
        } 
        this.cards.push(card);
      }
      this.cards = this.cards.map(card => ({ ...card }));
    }
  }
}
